import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export function selectorSharedFileReUploadAttempts(
  sharedFile: ISharedFileRequestResponse | undefined
): number {
  let count = 0;
  const isFirstAttemptUsed = !!sharedFile?.jobs.length;

  if (selectorIsSharedFileNotNoneContext(sharedFile?.contextType)) {
    count = sharedFile?.uploadHistory?.length || 0;
  }

  return count + (isFirstAttemptUsed ? 1 : 0);
}
